import { Outlet, useNavigate } from "react-router-dom";
import { useHandleProjectState } from "@pages/project/useHandleProjectState";
import { useEffect } from "react";

const PublicLayout = () => {
  const { project, isLoading } = useHandleProjectState();
  const navigate = useNavigate();

  useEffect(() => {
    if (project && !isLoading && !project?.is_public)
      navigate("/auth/login")
  }, [isLoading, project])

  return (<Outlet />);
};

export default PublicLayout;
